// src/utils/gltf.ts

import * as THREE from 'three';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';

// Registro de la escena activa (establecido desde dentro del Canvas)
let registeredScene: THREE.Scene | null = null;

export function registerScene(scene: THREE.Scene): void {
  registeredScene = scene;
}

export function getCurrentScene(): THREE.Scene | null {
  return registeredScene;
}

/**
 * Exporta la escena actual como un archivo .gltf (texto JSON) y lo descarga.
 */
export function exportSceneAsGLTF(scene: THREE.Scene, siteName: string): void {
  const exporter = new GLTFExporter();
  const slug = (siteName || 'sitio')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

  exporter.parse(
    scene,
    (result) => {
      let json: string;
      if (result instanceof ArrayBuffer) {
        json = JSON.stringify({ binary: true, size: result.byteLength }, null, 2);
      } else {
        json = JSON.stringify(result, null, 2);
      }
      const blob = new Blob([json], { type: 'model/gltf+json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${slug}.gltf`;
      link.click();
      URL.revokeObjectURL(url);
    },
    (error) => {
      console.error('Error al exportar GLTF:', error);
    },
    { binary: false }
  );
}